import UserSumSubDocuments from './UserSumSubDocuments';

export default UserSumSubDocuments;
